/* src/app/builder-screen-beta/screen-launcher/screen-launcher.component.scss */
.screen-launcher-container {
  width: 100%;
  max-width: 100%;
  height: 100vh;
  padding: 0;
  margin: 0;
  background: #fff;
  overflow: auto;
  box-sizing: border-box;
}
.screen-launcher-container .canvas-wrapper {
  width: auto;
  min-width: 100%;
  height: auto;
  min-height: 100vh;
  margin: 0;
  background: #fff;
  padding: 0 0 100px 0;
  position: relative;
}
.fab-container {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 12px;
}
.fab-container .fab-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: -1;
  animation: fadeIn 0.3s ease;
}
.fab-container .fab-action {
  width: 48px;
  height: 48px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  animation: slideIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.fab-container .fab-action:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}
.fab-container .fab-action nz-icon {
  font-size: 20px;
}
.fab-container .fab-action.fab-action-inject {
  animation-delay: 0.05s;
}
.fab-container .fab-action.fab-action-preview {
  animation-delay: 0.1s;
}
.fab-container .fab-action.fab-action-clear {
  animation-delay: 0.15s;
}
.fab-container .fab-main {
  width: 56px;
  height: 56px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.fab-container .fab-main:hover {
  transform: scale(1.1);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
}
.fab-container .fab-main:active {
  transform: scale(0.95);
}
.fab-container .fab-main nz-icon {
  font-size: 24px;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.fab-container.expanded .fab-main nz-icon {
  transform: rotate(135deg);
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.8);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
.json-inject-modal .json-editor textarea {
  font-family:
    "Courier New",
    Courier,
    monospace;
  font-size: 13px;
  line-height: 1.6;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 12px;
  background-color: #fafafa;
}
.json-inject-modal .json-editor textarea:focus {
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}
.flow-preview-modal .flow-preview-json .json-display {
  font-family:
    "Courier New",
    Courier,
    monospace;
  font-size: 13px;
  line-height: 1.6;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 12px;
  background-color: #fafafa;
  max-height: 450px;
  overflow: auto;
  white-space: pre-wrap;
  word-wrap: break-word;
  margin: 0;
}
:host {
  display: block;
  width: 100%;
  height: 100vh;
  margin: 0;
  padding: 0;
  overflow: hidden;
  box-sizing: border-box;
}
:host > * {
  max-height: none !important;
}
::ng-deep .screen-launcher-container .canvas-controls {
  display: none !important;
}
::ng-deep .screen-launcher-container .canvas-item,
::ng-deep .screen-launcher-container .canvas-node {
  cursor: default !important;
}
::ng-deep .screen-launcher-container .canvas-item:hover,
::ng-deep .screen-launcher-container .canvas-node:hover {
  outline: none !important;
  box-shadow: none !important;
}
::ng-deep .screen-launcher-container .canvas-item.is-selected,
::ng-deep .screen-launcher-container .canvas-node.is-selected {
  outline: none !important;
  box-shadow: none !important;
}
::ng-deep .screen-launcher-container .component-actions,
::ng-deep .screen-launcher-container .remove-button,
::ng-deep .screen-launcher-container .drag-handle {
  display: none !important;
}
::ng-deep .screen-launcher-container .grid-overlay {
  display: none !important;
}
::ng-deep .screen-launcher-container .canvas-scroll-container {
  overflow-x: hidden !important;
  overflow-y: visible !important;
  max-height: none !important;
  height: auto !important;
  min-height: auto !important;
  width: 100% !important;
  max-width: 100% !important;
}
::ng-deep .screen-launcher-container .canvas-grid-container {
  overflow-x: hidden !important;
  overflow-y: visible !important;
  max-height: none !important;
  height: auto !important;
  min-height: auto !important;
  padding: 0 !important;
  width: 100% !important;
  max-width: 100% !important;
}
::ng-deep .screen-launcher-container .tab-content-grid {
  padding: 0 !important;
  margin: 0 !important;
  overflow-x: hidden !important;
  overflow-y: visible !important;
  max-height: none !important;
  height: auto !important;
  min-height: calc(100vh - 280px) !important;
  width: 100% !important;
  max-width: 100% !important;
  background: #fff !important;
}
::ng-deep .screen-launcher-container .ant-tabs-nav {
  margin: 0 !important;
  margin-bottom: 0 !important;
}
::ng-deep .screen-launcher-container .ant-table-wrapper,
::ng-deep .screen-launcher-container .ant-table-container {
  max-height: none !important;
  height: auto !important;
  min-height: auto !important;
  width: 100% !important;
  max-width: 100% !important;
}
::ng-deep .screen-launcher-container .ant-collapse,
::ng-deep .screen-launcher-container .ant-collapse-content,
::ng-deep .screen-launcher-container .ant-collapse-content-box,
::ng-deep .screen-launcher-container .ant-collapse-content-active,
::ng-deep .screen-launcher-container nz-collapse,
::ng-deep .screen-launcher-container nz-collapse-panel {
  overflow-x: hidden !important;
  overflow-y: visible !important;
  max-height: none !important;
  height: auto !important;
  min-height: 0 !important;
  max-width: 100% !important;
}
::ng-deep .screen-launcher-container nz-collapse-panel .ant-collapse-content {
  max-height: none !important;
  height: auto !important;
}
::ng-deep .screen-launcher-container nz-collapse-panel .ant-collapse-content .ant-collapse-content-box {
  max-height: none !important;
  height: auto !important;
  padding-bottom: 16px !important;
}
::ng-deep .screen-launcher-container nz-table {
  width: 100% !important;
  max-width: 100% !important;
}
::ng-deep .screen-launcher-container .table-wrapper {
  width: 100% !important;
  max-width: 100% !important;
  overflow: visible !important;
}
::ng-deep .screen-launcher-container .data-grid-container {
  overflow-x: hidden !important;
  overflow-y: visible !important;
  width: 100% !important;
  max-width: 100% !important;
}
::ng-deep .screen-launcher-container .data-grid-table {
  width: 100% !important;
  min-width: 100% !important;
  height: auto !important;
  max-height: none !important;
}
::ng-deep .screen-launcher-container .panel-container,
::ng-deep .screen-launcher-container .panel-content {
  overflow-x: hidden !important;
  overflow-y: visible !important;
  height: auto !important;
  max-height: none !important;
  min-height: 0 !important;
  max-width: 100% !important;
}
::ng-deep .screen-launcher-container .crud-actions,
::ng-deep .screen-launcher-container .action-buttons-container,
::ng-deep .screen-launcher-container button[nz-button] {
  position: relative !important;
  margin-bottom: 8px !important;
}
::ng-deep .screen-launcher-container .canvas-grid-container > *:last-child,
::ng-deep .screen-launcher-container .tab-content-grid > *:last-child,
::ng-deep .screen-launcher-container .panel-content > *:last-child {
  margin-bottom: 24px !important;
}
::ng-deep .screen-launcher-container app-builder-canvas-beta {
  display: block;
  width: 100% !important;
  max-width: 100% !important;
  padding: 0 !important;
  margin: 0 !important;
  overflow-x: hidden !important;
}
::ng-deep .screen-launcher-container nz-tabset,
::ng-deep .screen-launcher-container .ant-tabs {
  position: relative;
  z-index: 10 !important;
  width: 100% !important;
  max-width: 100% !important;
  overflow-x: hidden !important;
}
::ng-deep .screen-launcher-container .ant-tabs-nav,
::ng-deep .screen-launcher-container .ant-tabs-nav-wrap,
::ng-deep .screen-launcher-container .ant-tabs-tab {
  position: relative;
  z-index: 10 !important;
}
::ng-deep .screen-launcher-container .ant-tabs-content,
::ng-deep .screen-launcher-container .ant-tabs-content-holder {
  position: relative;
  z-index: 5;
  overflow-x: hidden !important;
  overflow-y: visible !important;
  height: auto !important;
  max-height: none !important;
  min-height: auto !important;
  width: 100% !important;
  max-width: 100% !important;
}
::ng-deep .screen-launcher-container .ant-tabs-tabpane,
::ng-deep .screen-launcher-container .ant-tabs-tabpane-active {
  overflow-x: hidden !important;
  overflow-y: visible !important;
  height: auto !important;
  max-height: none !important;
  min-height: calc(100vh - 280px) !important;
  width: 100% !important;
  max-width: 100% !important;
}
::ng-deep .screen-launcher-container input,
::ng-deep .screen-launcher-container textarea,
::ng-deep .screen-launcher-container select,
::ng-deep .screen-launcher-container button:not(.remove-button) {
  pointer-events: auto !important;
  cursor: auto !important;
}
::ng-deep .screen-launcher-container app-builder-canvas-beta,
::ng-deep .screen-launcher-container .canvas-wrapper,
::ng-deep .screen-launcher-container .canvas-scroll-container,
::ng-deep .screen-launcher-container .canvas-grid-container,
::ng-deep .screen-launcher-container nz-tabset,
::ng-deep .screen-launcher-container .ant-tabs,
::ng-deep .screen-launcher-container .ant-tabs-content-holder,
::ng-deep .screen-launcher-container .ant-tabs-content,
::ng-deep .screen-launcher-container .ant-tabs-tabpane,
::ng-deep .screen-launcher-container .ant-tabs-tabpane-active,
::ng-deep .screen-launcher-container .tab-content-grid,
::ng-deep .screen-launcher-container nz-collapse,
::ng-deep .screen-launcher-container nz-collapse-panel,
::ng-deep .screen-launcher-container .ant-collapse,
::ng-deep .screen-launcher-container .ant-collapse-content,
::ng-deep .screen-launcher-container .ant-collapse-content-box,
::ng-deep .screen-launcher-container app-data-grid,
::ng-deep .screen-launcher-container .data-grid-container,
::ng-deep .screen-launcher-container .ant-spin-container,
::ng-deep .screen-launcher-container .panel-container,
::ng-deep .screen-launcher-container .panel-content {
  overflow-x: hidden !important;
  overflow-y: visible !important;
  max-height: none !important;
  height: auto !important;
  width: 100% !important;
  max-width: 100% !important;
}
::ng-deep .screen-launcher-container .table-wrapper {
  overflow: visible !important;
  max-height: none !important;
  height: auto !important;
  width: 100% !important;
  max-width: 100% !important;
}
::ng-deep .screen-launcher-container nz-table {
  width: 100% !important;
  max-width: 100% !important;
}
::ng-deep .screen-launcher-container nz-table .ant-table-wrapper,
::ng-deep .screen-launcher-container nz-table .ant-table {
  width: 100% !important;
  max-width: 100% !important;
}
::ng-deep .screen-launcher-container .ant-table-thead > tr > th,
::ng-deep .screen-launcher-container .ant-table-tbody > tr > td {
  white-space: nowrap !important;
}
/*# sourceMappingURL=screen-launcher.component.css.map */
